import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Renew: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="none" d="M8 3C6.56658 3 5.16771 3.44006 3.99245 4.2607C2.81719 5.08134 1.9222 6.24301 1.42843 7.5887C0.934652 8.93438 0.865906 10.3992 1.23148 11.7852C1.59705 13.1713 2.37931 14.4116 3.47255 15.3387" strokeWidth="1.5" strokeLinecap="round" />;
    t1 = <path fill="none" d="M8 17C9.43342 17 10.8323 16.5599 12.0075 15.7393C13.1828 14.9187 14.0778 13.757 14.5716 12.4113C15.0653 11.0656 15.1341 9.60078 14.7685 8.21476C14.403 6.82874 13.6207 5.58836 12.5275 4.66125" strokeWidth="1.5" strokeLinecap="round" />;
    t2 = <path d="M9.60241 2.63272C9.81671 2.83068 9.81671 3.16932 9.60241 3.36728L7.08928 5.68881C6.76904 5.98464 6.25 5.7575 6.25 5.32154L6.25 0.678464C6.25 0.242498 6.76904 0.0153628 7.08928 0.311188L9.60241 2.63272Z" />;
    t3 = <path d="M6.39759 16.6327C6.18329 16.8307 6.18329 17.1693 6.39759 17.3673L8.91072 19.6888C9.23096 19.9846 9.75 19.7575 9.75 19.3215L9.75 14.6785C9.75 14.2425 9.23096 14.0154 8.91072 14.3112L6.39759 16.6327Z" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg {...props} fill="currentColor" stroke="currentColor" width="16" height="20" viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg">{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};